import styled from 'styled-components';

const CarouselPaginationContainer = styled.div`
  ul {
    padding-left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 5px auto 0;

    ${'' /* re-position of dot component */}
    position: absolute;
    width: 100%;
    top: 0;
    margin-top: 78%;
  }

  li {
    padding: 6px;
    list-style: none;

    div {
      transition: all 400ms;
    }

    &.slick-active {
      div {
        background-color: ${({ theme: { colors } }) => colors.primaryDark};
        border-color: white;
        border-width: 2px;
        height: 10px;
        border-radius: 20px;
      }
    }
  }
`;

export default CarouselPaginationContainer;
